import { RootState } from '../store';

export const getAdFromUrlActive = (state: RootState) => state.adFromUrl.isActive;
export const getAdFromUrlLoading = (state: RootState) => state.adFromUrl.loading;
export const getAdFromUrlGenerating = (state: RootState) => state.adFromUrl.isGenerating;
